import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';
import {ItemType} from 'antd/es/menu/interface';

import {UserType} from '../user/user-type';

import {AnalyticsEventEnum} from './analytics-type';

function findMenuItemByPathname(item: ItemType, pathname: string): boolean {
    return Boolean(item?.key && pathname.startsWith(item.key.toString()));
}

function getActiveLeftMenuText(pathname: string, menuItems: Array<ItemType>): string {
    const menuItem = menuItems.find((item) => findMenuItemByPathname(item, pathname));

    if (!menuItem) {
        return '';
    }

    const childrenMenuItem =
        'children' in menuItem && menuItem.children?.find((item) => findMenuItemByPathname(item, pathname));

    if (childrenMenuItem) {
        return childrenMenuItem[nameForAnalytics] || '';
    }

    return '';
}

export function pushToDataLayer(data: Record<string, unknown>): void {
    if (!Array.isArray(window.dataLayer)) {
        return;
    }

    window.dataLayer.push(data);
}

export function trackNavigationGoogleAnalytics(
    pathname: string,
    previousPathname: string,
    menuItems: Array<ItemType>
): void {
    pushToDataLayer({
        previousSectionComb: getActiveLeftMenuText(previousPathname, menuItems),
        sectionComb: getActiveLeftMenuText(pathname, menuItems),
    });
}

export function initializeGoogleAnalytics(user: UserType): void {
    // using allowlist to make sure that no personal fields are sent (email, profile)
    pushToDataLayer({
        event: AnalyticsEventEnum.RocketdataEvent,
        eventCategory: 'User Data',
        eventAction: 'User Pageview',
        eventLabel: '',
        id: user.id,
        language: user.language,
        is_staff: user.isStaff,
        is_rocketdata: !user?.isStaff && user?.email.endsWith('rocketdata.io'),
        is_test_user: user.isTestUser,
        is_demo_user: user.isDemoCpUser,
        is_double_gis_trusted: user.isDoubleGisTrusted,
    });
}
